import { useEffect } from "react";

const useOutsideClick = (ref, callback) => {
  const handleClick = (e) => {

    if (ref.current && !ref.current.contains(e.target)) {
      callback();
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClick);

    return () => {
      document.removeEventListener("mousedown", handleClick);
    };
  }, [ref]);
};

export default useOutsideClick;
